import { Entity } from '../entity.js';
import { EFFECT_TYPES } from '../combat/statusEffects.js';
import { clampGroundCast, isInAbilityCircle, isInAbilityLine } from '../combat/abilityArea.js';

export function createLux(id = 'lux-1', team = 'blue', x = 300, y = 1300) {
  const lux = new Entity({
    id,
    type: 'champion',
    team,
    x,
    y,
    maxHp: 528,
    maxMp: 480,
    ad: 55,
    ap: 0,
    armor: 24,
    mr: 30,
    ms: 330,
    attackRange: 550,
    attackSpeed: 0.625,
    name: 'Lux',
    radius: 20
  });
  lux.prismaticBarrierActive = false;
  lux.shieldHp = 0;
  return lux;
}

export function castLuxQ(caster, targetX, targetY, projectiles, gameTime) {
  if (!caster || caster.isDead || caster.mp < 50) return false;
  caster.mp -= 50;
  const angle = Math.atan2(targetY - caster.y, targetX - caster.x);
  const damage = 55 + (caster.ap || 0) * 0.7;
  projectiles.push({
    id: `lux-q-${caster.id}-${gameTime}`,
    casterId: caster.id,
    team: caster.team,
    x: caster.x,
    y: caster.y,
    vx: Math.cos(angle) * 1200,
    vy: Math.sin(angle) * 1200,
    range: 1300,
    traveled: 0,
    damage,
    damageType: 'magic',
    radius: 70,
    onHitStatus: EFFECT_TYPES.ROOT
  });
  return true;
}

function applyPrismaticShield(unit, amount) {
  unit.prismaticBarrierActive = true;
  unit.shieldHp = (unit.shieldHp || 0) + amount;
}

function shieldAlliesOnSegment(caster, targetX, targetY, entities, amount) {
  const angle = Math.atan2(targetY - caster.y, targetX - caster.x);
  for (const e of entities || []) {
    if (!e || e.isDead || e.team !== caster.team || e === caster) continue;
    if (!isInAbilityLine(e, caster.x, caster.y, angle, 1150, 110, caster)) continue;
    applyPrismaticShield(e, amount);
  }
}

export function castLuxW(caster, targetX, targetY, projectiles, gameTime, entities = []) {
  if (!caster || caster.isDead || caster.mp < 60) return false;
  caster.mp -= 60;
  const shield = 70 + (caster.ap || 0) * 0.35;
  applyPrismaticShield(caster, shield);
  shieldAlliesOnSegment(caster, targetX, targetY, entities, shield);
  const angle = Math.atan2(targetY - caster.y, targetX - caster.x);
  projectiles.push({
    id: `lux-w-${caster.id}-${gameTime}`,
    casterId: caster.id,
    team: caster.team,
    x: caster.x,
    y: caster.y,
    vx: Math.cos(angle) * 1400,
    vy: Math.sin(angle) * 1400,
    range: 1150,
    traveled: 0,
    damage: 0,
    damageType: 'magic',
    radius: 110,
    isBoomerang: true,
    shieldAmount: shield
  });
  return true;
}

export function castLuxE(caster, x, y, entities = []) {
  if (!caster || caster.isDead || caster.mp < 70) return false;
  caster.mp -= 70;
  const aim = clampGroundCast(caster, x, y, 1100);
  const damage = 60 + (caster.ap || 0) * 0.6;
  for (const e of entities) {
    if (!e || e.isDead || e.team === caster.team) continue;
    if (!isInAbilityCircle(e, aim.x, aim.y, 310, caster)) continue;
    e.takeDamage(damage, caster, 'magic');
    e.statusManager?.addEffect?.(EFFECT_TYPES.SLOW, 1.5, 0.35);
  }
  return true;
}

export function castLuxR(caster, targetX, targetY, entities = []) {
  if (!caster || caster.isDead || caster.mp < 100) return false;
  caster.mp -= 100;
  const angle = Math.atan2(targetY - caster.y, targetX - caster.x);
  const damage = 185 + (caster.ap || 0) * 0.75;
  for (const e of entities) {
    if (!e || e.isDead || e.team === caster.team) continue;
    if (!isInAbilityLine(e, caster.x, caster.y, angle, 3400, 100, caster)) continue;
    e.takeDamage(damage, caster, 'magic');
  }
  return true;
}
